import { SendTeamsMessageForm } from '@features/send-teams-message/components/SendTeamsMessageForm'
import { Box, Card } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/tools/send-teams-message')({
    beforeLoad: requireRouteAudience(['staff']),
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Send a Teams message',
        }
    }
})

function RouteComponent() {
    return (
        <Box p={'xs'}>
            <Card
                withBorder
                p='lg'
            >
                <SendTeamsMessageForm />
            </Card>
        </Box>
    )
}
